import Decimal from 'bignumber.js';
import {Decoverto} from 'decoverto';

import {DecimalConverter} from '../../grapqhl/types/decimal.type';

export const decoverto = new Decoverto();
decoverto.converterMap.set(Decimal, new DecimalConverter());
